import { INVITATION_QUERY_PARAM, invitationOffer, type InvitationOffer } from '@alexiarest/shared';

/**
 * Oferta por invitación (…/?invitacion=ALEXFAMILY).
 *
 * El código llega en la URL que comparte Alex y tiene que sobrevivir al alta:
 * registro, correo de verificación, login con Google… La URL sola se pierde
 * por el camino, así que se guarda en localStorage nada más cargar la app. En
 * el alta pasa al tenant (y ya no depende del navegador); en el checkout se
 * manda también por si el restaurante existía antes de abrir el enlace.
 */
const STORAGE_KEY = 'alexia:invitacion';

/** Llamar al arrancar, antes de cualquier redirección de login. */
export function rememberInvitation(search: string = window.location.search): void {
  const code = new URLSearchParams(search).get(INVITATION_QUERY_PARAM)?.trim().toUpperCase();
  if (!code || !invitationOffer(code)) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, code);
  } catch {
    /* modo privado: queda la URL mientras dure */
  }
}

/** Código guardado (o el de la URL), solo si su oferta sigue abierta. */
export function storedInvitation(search: string = window.location.search): string | undefined {
  let code = new URLSearchParams(search).get(INVITATION_QUERY_PARAM) ?? '';
  try {
    code = code || window.localStorage.getItem(STORAGE_KEY) || '';
  } catch {
    /* sin almacenamiento */
  }
  return invitationOffer(code)?.code;
}

/** La oferta que le toca a este restaurante: la del tenant manda sobre la del navegador. */
export function invitationOfferFor(tenant?: { invitation?: string }): InvitationOffer | null {
  return invitationOffer(tenant?.invitation) ?? invitationOffer(storedInvitation());
}
